import React from "react";
import PublicLegalTextPage from "./PublicLegalTextPage";

const KullaniciSozlesmesi = () => <PublicLegalTextPage field="terms" title="Kullanım Koşulları ve Üyelik Sözleşmesi" />;

export default KullaniciSozlesmesi;
